export const setBodyScrollability = (shouldScroll: boolean) => {
  if (shouldScroll) {
    document.body.style.overflow = "";
  } else {
    document.body.style.overflow = "hidden";
  }
};
;
import "/Users/igor/Duffel/duffel-components/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";